import React from 'react';

import { useForm } from 'react-hook-form';
import { NavLink } from 'react-router-dom';

import { useAuth } from '../../common/hooks';
import BrainHiLogo from '../../common/images/brainhi_logo_primary.svg';

const Login: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const { login } = useAuth();

  const onSubmit = async ({
    username,
    password,
  }: {
    username: string;
    password: string;
  }): Promise<void> => {
    await login(username, password);
  };

  return (
    <div className="flex flex-col">
      <img className="w-auto h-12 mx-auto" src={BrainHiLogo} alt="BrainHi" />
      <h2 className="mx-auto mt-6">Sign in to your account</h2>
      <form className="flex flex-col mt-6" onSubmit={handleSubmit(onSubmit)}>
        <label htmlFor="username" className="input-label">
          Username
          <input
            id="username"
            type="text"
            className="input sm:text-sm w-full mt-1 transition duration-150 ease-in-out appearance-none"
            {...register('username', { required: true })}
            data-testid="username"
          />
        </label>
        {errors.username && (
          <p className="error-text" data-testid="username-error">
            The username is required
          </p>
        )}
        <label htmlFor="password" className="input-label mt-6">
          Password
          <input
            id="password"
            type="password"
            className="input sm:text-sm w-full mt-1 transition duration-150 ease-in-out appearance-none"
            {...register('password', { required: true })}
            data-testid="password"
          />
        </label>
        {errors.password && (
          <p className="error-text" data-testid="password-error">
            The password is required
          </p>
        )}
        <NavLink
          className="text-primary-3.0 transition duration-150 ease-in-out ml-auto mt-2 cursor-pointer"
          to="/reset_password"
          data-testid="forgot-password"
        >
          Forgot your password?
        </NavLink>
        <button
          type="submit"
          className="btn btn-secondary flex justify-center w-full px-4 py-2 mt-6 transition duration-150 ease-in-out"
          data-testid="login-btn"
        >
          Sign in
        </button>
      </form>
    </div>
  );
};

export default Login;
